import * as actionTypes from './actionTypes';
import * as actions from './index';

export const loadDevices = () => {
    return dispatch => {
        dispatch({ type: actionTypes.DEVICE_LOAD_START });

        window.flow.searchDevice({typename:'flowcenter'}).then(res => {
            dispatch({ type: actionTypes.DEVICE_LOAD_SUCCESS, devices: res});
        }).catch(res => {
            dispatch({ type: actionTypes.DEVICE_LOAD_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const setSearchDevices = (devices) => {
    return dispatch => {
        dispatch({ type: actionTypes.DEVICE_SET_SEARCH, devices: devices});
    };
};
